import React from "react";
import PropTypes from "prop-types";
import RaisedButton from "@mui/material/Button";
import { withStyles } from "@mui/styles";
import { styles } from "./styles";

class WrongAccount extends React.Component {
  renderDetail = (label, value) => {
    const { classes } = this.props;

    return (
      <div className={classes.wrong_account_detail_row}>
        <span className={classes.wrong_account_detail_label}>{label}</span>
        <span className={classes.wrong_account_detail_value}>{value}</span>
      </div>
    );
  };

  render() {
    const { classes, approver, current_email } = this.props;
    const contact_name = approver ? approver.contact_name : null;
    const email_hint = approver ? approver.email_hint : null;
    const has_details = Boolean(contact_name || email_hint);

    return (
      <div className={"box box-default " + classes.card}>
        <div className="box-body text-center">
          <span className={"material-icons " + classes.wrong_account_icon}>
            account_circle
          </span>
          <h2 className={"article-title " + classes.wrong_account_title}>
            You are signed in with a different account
          </h2>
          {current_email && (
            <p className={classes.wrong_account_current}>
              Signed in as {current_email}
            </p>
          )}
          <p className={classes.wrong_account_text}>
            {has_details
              ? "This cashbox approval request was sent to another account. Sign in with the account below to review it."
              : "This cashbox approval request was sent to another account. Sign in with the account it was sent to in order to review it."}
          </p>
          {has_details && (
            <div className={classes.wrong_account_details}>
              {contact_name && this.renderDetail("Name", contact_name)}
              {email_hint && this.renderDetail("Email", email_hint)}
            </div>
          )}
          <RaisedButton
            variant="contained"
            fullWidth
            className={classes.wrong_account_button}
            onClick={this.props.handleSignInWithAnotherAccount}
          >
            Sign in with a different account
          </RaisedButton>
        </div>
      </div>
    );
  }
}

WrongAccount.propTypes = {
  classes: PropTypes.object.isRequired,
  approver: PropTypes.object,
  current_email: PropTypes.string,
  handleSignInWithAnotherAccount: PropTypes.func.isRequired
};

export default withStyles(styles)(WrongAccount);
